import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { getChoicesCountries } from '../../../../../modules/actions/choices'
import { choicesCountriesWasLoadedSelector } from '../../../../../modules/selectors/choices'

const useInitialDataManagement = props => {
  PropTypes.checkPropTypes(propTypes, props, 'prop', 'useInitialDataManagement')

  const dispatch = useDispatch()

  const countriesWasLoaded = useSelector(choicesCountriesWasLoadedSelector)

  const { isLineItemsExist, setIsFirstLineItemCreation } = props

  // separate state to prevent bug, when LineItemStep becomes visible after first line item creation
  useEffect(() => {
    if (!isLineItemsExist) {
      setIsFirstLineItemCreation(true)
    }
  }, [isLineItemsExist, setIsFirstLineItemCreation])

  useEffect(() => {
    // getChoicesCountries for payload creation
    if (!countriesWasLoaded) {
      dispatch(getChoicesCountries())
    }
  }, [dispatch, countriesWasLoaded])
}

const propTypes = {
  isLineItemsExist: PropTypes.bool.isRequired,
  setIsFirstLineItemCreation: PropTypes.func.isRequired
}

export default useInitialDataManagement
